var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTractor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    fill: "white",
    stroke: "#2A2D34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32617 11.232C2.32617 12.3867 2.54154 13.6667 3.59304 13.6667H3.9606C3.9606 13.6667 3.9606 12.2175 5.26829 12.2754C6.57598 12.3334 6.57598 13.6667 6.57598 13.6667H7.22983C7.22983 12.9015 7.92833 12.2754 8.62511 12.2754C9.32189 12.2754 9.84521 12.9015 9.84521 13.6667H14.198C14.198 12.9015 14.768 12.2754 15.4648 12.2754C16.1616 12.2754 16.8482 12.9015 16.8482 13.6667H17.0991C18.1506 13.6667 18.9994 12.7346 18.9994 11.5798V11.232H17.0991C16.7507 11.232 16.5213 11.0494 16.5213 10.6667V8.57979C16.5213 8.19718 17.0167 7.7537 17.3651 7.7537H18.6723L18.0185 6.66675C16.7108 6.66675 16.453 5.66675 15.9969 5.66675H14.8314V9.84066C14.8314 10.6059 14.2613 11.232 13.5645 11.232H12.9311",
    stroke: "#2A2D34",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53816 14.9999C9.26038 14.9999 9.84585 14.403 9.84585 13.6666C9.84585 12.9302 9.26038 12.3333 8.53816 12.3333C7.81594 12.3333 7.23047 12.9302 7.23047 13.6666C7.23047 14.403 7.81594 14.9999 8.53816 14.9999Z",
    stroke: "#2A2D34",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5421 14.9999C16.2643 14.9999 16.8498 14.403 16.8498 13.6666C16.8498 12.9302 16.2643 12.3333 15.5421 12.3333C14.8198 12.3333 14.2344 12.9302 14.2344 13.6666C14.2344 14.403 14.8198 14.9999 15.5421 14.9999Z",
    stroke: "#2A2D34",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 9.66675V11.2413H17.132C16.721 11.2413 16.3848 10.9413 16.3848 10.5746V8.33341C16.3848 7.96675 16.721 7.66675 17.132 7.66675H18.6732L19.0002 9.66675Z",
    stroke: "#2A2D34",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4414 11V5",
    stroke: "#2A2D34",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26863 14.9999C5.99085 14.9999 6.57632 14.403 6.57632 13.6666C6.57632 12.9302 5.99085 12.3333 5.26863 12.3333C4.54641 12.3333 3.96094 12.9302 3.96094 13.6666C3.96094 14.403 4.54641 14.9999 5.26863 14.9999Z",
    stroke: "#2A2D34",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTractor);
export default __webpack_public_path__ + "static/media/Icon_tractor.2d8ca4ac2f3b7c55bcf69ac83b061f9c.svg";
export { ForwardRef as ReactComponent };